<template>
  <div class="practice-hands practicepage">
    <div class="practicepage_inner">
      <PracticeSessionsTableV2 />
    </div>
  </div>
</template>

<script>
import PracticeSessionsTableV2 from '@/components/DataTables/v2/tables/PracticeSessionsTableV2/PracticeSessionsTableV2'

export default {
  name: 'PracticeHands',

  components: {
    PracticeSessionsTableV2,
  },
  data() {
    return {}
  },
}
</script>
